const carousel = () => {
  return {
    DOMelem: null,
    scrollContainer: null,
    nextBtn: null,
    prevBtn: null,
    products: [],
    productWidth: 0,
    margin: 4,
    maxProducts: 0,
    stepWidth: 4,
    steps: 0,
    currentStep: 1,
    hasMoreSteps: false,
    hasPrevSteps: false,
    viewWidth: window.innerWidth,

    init: function(element) {
      if ( !element ) {
        console.warn('No HTMLelement supplied to carousel.init() in akb-featured-collection.js');
        return false;
      }

      this.DOMelem = element;
      this.scrollContainer = element.querySelector('.akb-scroll-container');
      this.nextBtn = element.querySelector('.akb-carousel-nav');
      this.prevBtn = element.querySelector('.akb-carousel-nav-prev');

      this.products = [... element.querySelectorAll('.akb-carousel-product')];
      this.maxProducts = this.products.length;

      if ( this.products.length > 0 ) {
        this.calcSteps();
        this.eventListeners();
      }
    },

    calcSteps: function() {
      let elemDimensions = this.products[0].getBoundingClientRect(); // get size from first product
      this.productWidth = elemDimensions.width + this.margin;

      if ( this.viewWidth >= 320 ) {
        this.stepWidth = 2;
      }

      if ( this.viewWidth >= 1065 ) {
        this.stepWidth = 4;
      }

      this.steps = Math.ceil(this.maxProducts / this.stepWidth);
      this.hasMoreSteps = this.maxProducts > this.stepWidth ? true : false;

      this.updateNav();
    },

    eventListeners: function() {
      let self = this;

      this.nextBtn.addEventListener('click', function() {
        self.next();
      });

      this.prevBtn.addEventListener('click', function() {
        self.prev();
      });

      window.addEventListener('resize', function() {
        self.viewWidth = window.innerWidth;
        self.calcSteps();  
      });
    },

    next: function() {
      if ( this.currentStep < this.steps ) {
        let amount = this.stepWidth * this.productWidth;
        this.scroll(amount);
        this.currentStep++;
        this.updateNav();
      }
    },

    prev: function() {
      if ( this.currentStep > 1 ) {
        let amount = (this.stepWidth * this.productWidth) * -1;
        this.scroll(amount);
        this.currentStep--;
        this.updateNav();
      }
    },

    scroll: function(amount = (this.productWidth * this.stepWidth)) {
      let curScroll = this.scrollContainer.scrollLeft;

      this.scrollContainer.scrollTo({
        top: 0,
        left: curScroll + amount,
        behavior: 'smooth'
      });
    },

    updateNav: function() {
      this.hasMoreSteps = this.currentStep < this.steps ? true : false;
      this.hasPrevSteps = this.currentStep > 1;

      if ( this.hasMoreSteps && this.nextBtn.classList.contains('hidden') ) {
        this.nextBtn.classList.remove('hidden');
      }

      if ( !this.hasMoreSteps && !this.nextBtn.classList.contains('hidden') ) {
        this.nextBtn.classList.add('hidden');
      }

      if ( this.hasPrevSteps && this.prevBtn.classList.contains('hidden') ) {
        this.prevBtn.classList.remove('hidden');
      }

      if ( !this.hasPrevSteps && !this.prevBtn.classList.contains('hidden') ) {
        this.prevBtn.classList.add('hidden');
      }
    }
  }
}


const akbFCHandler = () => {
  const carousels = [... document.querySelectorAll('.akb-carousel')];

  if ( carousels.length > 0 ) {
    carousels.forEach((elem) => {
      const carouselHandler = carousel();
      carouselHandler.init(elem);
    });
  }
}

akbFCHandler();